interface QLogoProps {
  logoURL: string;
  logoHeight: string | number;
  href?: string;
}

const isQerpTheme = () =>
  typeof document !== "undefined" && document.body.classList.contains("qerp-theme");

const QLogo = ({ logoURL, logoHeight, href }: QLogoProps) => {
  // Brand wordmark, not translated; shown only with the full logo (expanded sidebar).
  const showEnterprise = isQerpTheme() && logoURL === "qoyodWLogo";
  const Wrapper: React.ElementType = href ? "a" : "div";
  return (
    <Wrapper
      href={href}
      style={{
        height: 64,
        display: "flex",
        flexDirection: showEnterprise ? "column" : "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        srcSet={`/assets/logos/${logoURL}/small.png 480w,
              /assets/logos/${logoURL}/medium.png 800w,
              /assets/logos/${logoURL}/large.png 1200w`}
        sizes="(max-width: 480px) 480px,
              (max-width: 800px) 800px,
              1200px"
        src={`/assets/logos/${logoURL}/large.png`}
        alt="qyd_logo"
        style={{ height: logoHeight }}
      />
      {showEnterprise && (
        <span
          style={{
            color: "#fff",
            fontStyle: "italic",
            fontWeight: 600,
            fontSize: 13,
            letterSpacing: "0.06em",
            lineHeight: 1,
            marginTop: 3,
          }}
        >
          Enterprise
        </span>
      )}
    </Wrapper>
  );
};

export default QLogo;
